import React from 'react';
import { IllustrationProps } from './SuccessIllustration';
import IllustrationState from '.';
import { Image } from '@mantine/core';
import LoadingImage from '../../../assets/img/logo-beelajar.png';
import './styles.scss';

const LoadingIllustration: React.FC<IllustrationProps> = ({
  title = 'Preparing Data',
  description = 'Please wait... Currently collecting data...',
  h = '80vh',
  heightImage = 200
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: h as any
      }}
    >
      <IllustrationState
        Illustration={
          <Image
            className="loading-image"
            src={LoadingImage}
            h={heightImage}
            w="auto"
            fit="contain"
          />
        }
        description={description}
        title={title}
      />
    </div>
  );
};

export default LoadingIllustration;
